<ion-list-header [ngClass]="{ 'no-top-padding': !topPadding }" mode="md" color="light">
  <ng-content></ng-content>
</ion-list-header>
<ion-item-divider></ion-item-divider>
